var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.88894 11.1338L6.11475 13.6905H7.66313L6.88894 11.1338Z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8317 0H9.44462V4.12371H12.5414V5.7732H2.47688C1.16075 5.7732 0.154297 6.84536 0.154297 8.24742V17.3196C0.154297 18.7217 1.16075 19.7938 2.47688 19.7938H3.25107V24L8.12849 19.7938H13.3156V14.0206H21.8317C23.1478 14.0206 24.1543 12.9485 24.1543 11.5464V2.47423C24.1543 1.07217 23.1478 0 21.8317 0ZM8.51559 16.4124L8.12849 15.0928H5.72849L5.26397 16.4124H3.40591L5.96075 9.07217H7.81881L10.3737 16.4124H8.51559ZM20.2833 9.89691V11.5464C19.2769 11.5464 18.193 11.2165 17.264 10.7217C16.3349 11.2165 15.2511 11.4639 14.1672 11.5464L14.0898 9.89691C14.6317 9.89691 15.1737 9.81443 15.7156 9.64948C15.0188 8.90722 14.5543 8 14.322 7.01031H15.9478C16.1801 7.75258 16.6446 8.3299 17.1866 8.82474C18.0382 8.08247 18.5801 7.01031 18.6575 5.7732H14.0124V4.12371H16.3349V2.47423H17.8833V4.12371H20.4382L20.5156 4.94845C20.593 6.68041 19.9737 8.41237 18.8124 9.64948C19.3543 9.81443 19.8188 9.89691 20.2833 9.89691Z",
    fill: "#3C3C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language-icon.1590272139d1c916b52a7e0b15c77f23.svg";
export { ForwardRef as ReactComponent };